"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const icons_1 = require("../../atoms/icons");
const buttons_1 = require("../../atoms/buttons");
const faExternalLink_1 = require("@fortawesome/pro-regular-svg-icons/faExternalLink");
const MobileContainer = ({ children, isMobile, translations, externalLinks, toggleShow, onLogout, onBack }) => ((0, jsx_runtime_1.jsxs)(Container, { children: [isMobile && ((0, jsx_runtime_1.jsx)("div", { "data-back": true, onClick: onBack, children: (0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", icon: ["far", "arrow-left"], size: "lg" }, void 0) }, void 0)), children, isMobile && ((0, jsx_runtime_1.jsxs)("div", { "data-buttons": true, children: [(0, jsx_runtime_1.jsx)(buttons_1.Button, { onClick: toggleShow, variant: "primary", children: translations.changePasswordLink }, void 0), externalLinks.map(({ title, href }) => ((0, jsx_runtime_1.jsxs)(StyledButton, { href: href, variant: "tertiary", isExternal: true, children: [title, (0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangleSmall", icon: faExternalLink_1.faExternalLink, size: "1x" }, void 0)] }, title))), (0, jsx_runtime_1.jsx)(buttons_1.Button, { onClick: onLogout, variant: "link", children: translations.logout }, void 0)] }, void 0))] }, void 0));
exports.MobileContainer = MobileContainer;
const StyledButton = (0, styled_components_1.default)(buttons_1.Button) `
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: ${({ theme }) => `${theme.spacings.m} 0`};
  font-weight: 500;
`;
const Container = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.silverLighten40};
  width: 100%;

  div[data-back] {
    margin: ${({ theme }) => theme.spacings.m};

    & > div {
      background-color: transparent;
    }
  }

  div[data-buttons] {
    padding: ${({ theme }) => theme.spacings.m};

    button {
      margin-bottom: ${({ theme }) => theme.spacings.m};
      text-transform: capitalize;
    }

    button:not(:first-of-type) {
      display: flex;
      font-weight: 500;
      justify-content: space-between;

      &:before {
        display: none;
      }
    }

    button:last-of-type {
      display: flex;
      font-size: 0.875rem;
      justify-content: center;
      margin: ${({ theme }) => `${theme.spacings.xl} 0 ${theme.spacings.xs}`};
      width: 100%;
    }
  }
`;
//# sourceMappingURL=MobileContainer.js.map